import RuleBodyPage from "components/common/RuleBodyPage";
import { RuleModalBodyProps } from "components/common/RuleModal";
import { useTranslation } from "react-i18next";

function JorneyToHomeRuleBody({ page }: RuleModalBodyProps) {
  const { t } = useTranslation();
  const phaseContainer = "flex items-center gap-3 p-3 bg-gray-800 rounded-lg";
  const iconContainer =
    "w-8 h-8 min-w-9 min-h-9 flex items-center justify-center rounded-full text-sm";
  const rules = t("J2H.rules", { returnObjects: true }) as string[];

  return (
    <div className="relative flex">
      {/* Page 1: 게임 소개 및 기본 규칙 */}
      <RuleBodyPage show={page === 0}>
        <div className="space-y-4">
          <div className="text-gray-100">{rules[0]}</div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-green-600`}>
              <i className="fas fa-map-marker-alt" />
            </div>
            <div>
              <div className="font-medium text-green-300 mb-1">
                {t("J2H.hometownAssignment")}
              </div>
              <div className="text-sm text-gray-300">{rules[1]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-blue-600`}>
              <i className="fas fa-walking" />
            </div>
            <div>
              <div className="font-medium text-blue-300 mb-1">
                {t("J2H.movementRules")}
              </div>
              <div className="text-sm text-gray-300">{rules[2]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 2: 게임 진행 단계 */}
      <RuleBodyPage show={page === 1}>
        <div className="space-y-4">
          <div className="text-gray-100">{rules[3]}</div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-yellow-600`}>
              <i className="fas fa-square" />
            </div>
            <div>
              <div className="font-medium text-yellow-300 mb-1">
                {t("J2H.squarePhase")}
              </div>
              <div className="text-sm text-gray-300">{rules[4]}</div>
            </div>
          </div>
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-purple-600`}>
              <i className="fas fa-users" />
            </div>
            <div>
              <div className="font-medium text-purple-300 mb-1">
                {t("J2H.areaPhase")}
              </div>
              <div className="text-sm text-gray-300">{rules[5]}</div>
            </div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 3: 지역 및 승리 조건 */}
      <RuleBodyPage show={page === 2}>
        <div className="space-y-4">
          <div className={`${phaseContainer}`}>
            <div className={`${iconContainer} bg-indigo-600`}>
              <i className="fas fa-map" />
            </div>
            <div>
              <div className="font-medium text-indigo-300 mb-1">
                {t("J2H.areaInfo")}
              </div>
              <div className="text-sm text-gray-300">{rules[6]}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 mb-2">
            <div className={`${phaseContainer} bg-sky-500/20`}>
              <i className="fas fa-cloud text-sky-400" />
              <div>{t("J2H.Sky")}</div>
            </div>
            <div className={`${phaseContainer} bg-green-700/20`}>
              <i className="fas fa-tree text-green-400" />
              <div>{t("J2H.Forest")}</div>
            </div>
            <div className={`${phaseContainer} bg-blue-700/20`}>
              <i className="fas fa-droplet text-blue-400" />
              <div>{t("J2H.River")}</div>
            </div>
            <div className={`${phaseContainer} bg-stone-500/20`}>
              <i className="fas fa-city text-stone-400" />
              <div>{t("J2H.City")}</div>
            </div>
          </div>
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-green-300 mb-2">
              {t("J2H.winCondition")}
            </div>
            <ul className="list-disc list-inside space-y-2 text-sm text-gray-300 mb-3">
              <li className="flex items-center gap-2">
                <i className="fas fa-users text-blue-400" />
                <span>
                  {t("J2H.playersInArea")}: {rules[7]}
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fas fa-house-user text-green-400" />
                <span>
                  {t("J2H.playersInHometown")}: {rules[8]}
                </span>
              </li>
            </ul>
            <div className="text-sm text-gray-300">{rules[9]}</div>
          </div>
        </div>
      </RuleBodyPage>

      {/* Page 4: 전략 & 예시 */}
      <RuleBodyPage show={page === 3}>
        <div className="space-y-4">
          <div className="bg-gray-800 rounded-lg p-4 border border-gray-700">
            <div className="font-medium text-purple-300 mb-2">
              {t("J2H.strategyGuide")}
            </div>
            <ul className="list-disc list-inside space-y-2 text-sm text-gray-300">
              <li>{rules[12]}</li>
              <li>{rules[15]}</li>
            </ul>
          </div>

          {/* <div className="bg-green-900/20 border border-green-700/30 p-4 rounded-lg">
            <div className="font-medium text-green-300 mb-2">
              {t("J2H.gameExampleTitle")}
            </div>
            <div className="space-y-2 text-sm text-gray-300">
              <div>{rules[17]}</div>
              <div>{rules[18]}</div>
              <div>{rules[19]}</div>
              <div>{rules[20]}</div>
            </div>
          </div> */}
        </div>
      </RuleBodyPage>
    </div>
  );
}

export default JorneyToHomeRuleBody;
